/**
 * WD header: mega menu patches for when the search row is below the main header.
 * Loads after menu-dropdown.js and only changes behavior for .wd-header--search-at-bottom:
 * - adjusts the background --height on open
 * - delays closing on mouseleave, so the pointer can cross the search row into the dropdown
 */
(function () {
  const CLOSE_DELAY = 400;

  function getSearchAtBottomShell(headerSection) {
    if (!headerSection) return null;
    return headerSection.querySelector(
      'sticky-header.wd-header--search-at-bottom, .header-wrapper.wd-header--search-at-bottom'
    );
  }

  function patchMegaMenu() {
    const MegaMenu = customElements.get('mega-menu');
    if (!MegaMenu || MegaMenu.prototype.__wdSearchAtBottomPatched) return;

    const originalShowSublist = MegaMenu.prototype.showSublist;
    const originalBindEvent = MegaMenu.prototype.bindEvent;
    const originalHandleMouseleave = MegaMenu.prototype.handleMouseleave;

    MegaMenu.prototype.showSublist = function () {
      originalShowSublist.call(this);

      const headerSection = this.header || document.querySelector('.shopify-section-header');
      const headerShell = getSearchAtBottomShell(headerSection);
      if (!headerShell) return;

      const dropdown = this.querySelector('.list-menu-dropdown');
      const background = headerSection.querySelector('.header-background');
      if (!dropdown || !background) return;

      background.style.setProperty(
        '--height',
        headerShell.clientHeight + dropdown.clientHeight + 'px'
      );
    };

    MegaMenu.prototype.bindEvent = function () {
      originalBindEvent.call(this);

      // The dropdown is a descendant of the wrapper, so entering it (or any menu item) cancels a pending close
      if (this.wrapper && !this.__wdCancelCloseBound) {
        this.wrapper.addEventListener('mouseenter', () => clearTimeout(this.__wdCloseTimer));
        this.__wdCancelCloseBound = true;
      }
    };

    MegaMenu.prototype.handleMouseleave = function () {
      if (!getSearchAtBottomShell(this.header)) {
        originalHandleMouseleave.call(this);
        return;
      }

      clearTimeout(this.__wdCloseTimer);
      this.__wdCloseTimer = setTimeout(() => originalHandleMouseleave.call(this), CLOSE_DELAY);
    };

    // close() is called programmatically (e.g. drawers opening) and must stay immediate
    MegaMenu.prototype.close = function () {
      clearTimeout(this.__wdCloseTimer);
      originalHandleMouseleave.call(this);
    };

    MegaMenu.prototype.__wdSearchAtBottomPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchMegaMenu);
  } else {
    patchMegaMenu();
  }
})();
